<template>
  <div class="user-avatar" :title="fullName">
    <img
      v-if="user.circleFields?.avatar_url"
      :src="user.circleFields.avatar_url"
      :alt="fullName"
      class="avatar-img"
    />
    <div v-else class="avatar-fallback">
      {{ initials }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserAvatar',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    fullName() {
      return `${this.user.firstName || ''} ${this.user.lastName || ''}`.trim();
    },
    initials() {
      const first = this.user.firstName ? this.user.firstName[0] : '';
      const last = this.user.lastName ? this.user.lastName[0] : '';
      return (first + last).toUpperCase();
    }
  }
};
</script>

<style lang="scss" scoped>
.user-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: $color-surface-alt;
  border: 2px solid $color-primary;
  overflow: hidden;
  font-weight: 700;
  font-size: 1.1rem;
  color: $color-primary;
  box-shadow: 0 2px 8px rgba(170, 118, 214, 0.07);
}
.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.avatar-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 100%;
  background: $color-primary;
  color: #fff;
  font-size: 1.1rem;
}
</style>
